import { Badge } from "@/components/ui/badge";
import { Lock } from "lucide-react";

// Effective access state derived server-side (pos_billing.operating_entitlement). Never a manually maintained status.
export function BillingRestrictedBadge({ pb, cid }) {
  if (!pb?.billing_restricted) return null;
  const overdue = pb.billing_restriction_kind === "overdue";
  return (
    <Badge className="text-[10px] bg-rose-500/15 text-rose-700 border border-rose-500/30 tracking-wide inline-flex items-center gap-1" data-testid={`billing-restricted-badge-${cid}`}>
      <Lock className="w-3 h-3" /> RESTRICTED · {overdue ? "OVERDUE" : "PAYMENT REQUIRED"}
    </Badge>
  );
}

export function BillingRestrictedNotice({ pb }) {
  if (!pb?.billing_restricted) return null;
  return (
    <div className="rounded-lg border border-rose-500/30 bg-rose-500/5 px-3 py-2 text-xs" data-testid="billing-restricted-notice">
      <p className="font-semibold text-rose-700 flex items-center gap-1"><Lock className="w-3.5 h-3.5" /> {pb.billing_restriction_kind === "overdue" ? "Restricted · Overdue" : "Restricted · Payment Required"}</p>
      <p className="text-muted-foreground">{pb.billing_restriction_reason}. This account is currently restricted. Billing, Help &amp; Support, and Logout remain available. Clears automatically once a valid entitlement exists (e.g. payment confirmed by Stripe).</p>
    </div>
  );
}
